import React, { useState } from 'react';
import image1 from '../img/envision/aerospace/cards/experiance.JPG';
import image2 from '../img/envision/aerospace/cards/expertsandadvesers.jpg';
import image3 from '../img/envision/aerospace/cards/fivestar-ratting.jpg';

const AerospaceanimatedCards = () => {
  const [currentIndex, setCurrentIndex] = useState(0); // Default to first item

  const carouselItems = [
    {
      imgSrc: image1,
      altText: "image1",
      title: "DREBCON IS",
      description: "	Built with each resource with an average of 25+ years of experience working with 200+ clients in 10 countries."
    },
    {
      imgSrc: image2,
      altText: "image2",
      title: "DREBCON IS",
      description: "	Led by reputed experts and advisors with a proven track record across diverse sectors."
    },
    {
      imgSrc: image3,
      altText: "image3",
      title: "DREBCON IS",
      description: "	Driven by years of expertise and a customer-centric vision."
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === carouselItems.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? carouselItems.length - 1 : prevIndex - 1));
  };

  return (
    <div className='about-data-page-scroll'>
      <div className="page-container" style={{ marginTop: '120px', marginLeft: "450px" }}>
        <div className="carousel-container">
          <div className="carousel">
            {carouselItems.map((item, index) => {
              let itemClass = 'carousel__item';
              if (index === currentIndex) {
                itemClass += ' carousel__item--main';
              } else if (index === currentIndex - 1 || (currentIndex === 0 && index === carouselItems.length - 1)) {
                itemClass += ' carousel__item--left';
              } else if (index === currentIndex + 1 || (currentIndex === carouselItems.length - 1 && index === 0)) {
                itemClass += ' carousel__item--right';
              }

              return (
                <div key={index} className={itemClass}>
                  <img src={item.imgSrc} alt={item.altText} />
                </div>
              );
            })}

            <div className="carousel__description">
              <h2>{carouselItems[currentIndex].title}</h2>
              <p>{carouselItems[currentIndex].description}</p>
            </div>

            <hr
              className="carousel__hr"
              style={{
                width: `${(currentIndex + 1) / carouselItems.length * 100}%`, // Dynamically change width
              }}
            />

            <div className="carousel__btns">
              <button className="carousel__btn" onClick={prevSlide}>
                &lt;
              </button>
              <button className="carousel__btn" onClick={nextSlide}>
                &gt;
              </button>
            </div>
          </div>
        </div>

        <style jsx>{`
          .page-container {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            flex-direction: column;
            margin: 0;
          }

          .carousel-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 80%;
          }

          .carousel {
            position: relative;
            max-width: 90%;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
          }

          .carousel__item {
            position: absolute;
            height: 22rem;
            width: 25rem;
            border-radius: 8px;
            overflow: hidden;
            // box-shadow: 0 1rem 4rem rgba(0, 0, 0, 0.5);
            transform: translate(-50%, -50%) scale(0.5);
            z-index: 0;
            transition: all 0.3s ease-in-out;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }

          .carousel__item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .carousel__item--main {
            transform: translate(-50%, -50%) scale(1.1);
            z-index: 3;
            height: 25rem;
            width: 32rem;
            margin-top: 57px;
          }

          .carousel__item--left {
            transform: translate(-149%, -50%) scale(0.8);
            z-index: 1;
          }

          .carousel__item--right {
            transform: translate(30%, -50%) scale(0.8);
            z-index: 1;
          }

          .carousel__description {
            text-align: center;
            margin-top: 247px;
            margin-left: -109px;
            padding: 20px;
            border-radius: 8px;
            width: 80%;
            position: relative;
          }

          .carousel__description h2 {
            margin: 0;
            font-size: 1.5rem;
            color: rgb(236 115 34);
          }

          .carousel__description p {
            font-size: 20px;
            color: #555;
          }

          .carousel__btns {
            position: absolute;
            bottom: -60px;
            left: 83%;
            transform: translateX(-50%);
            display: flex;
            gap: 10px;
            top: 371px;
          }

          .carousel__btn {
            background-color: rgb(236 115 34);
            height: 3rem;
            width: 3rem;
            border-radius: 50%;
            border: none;
            color: #fff;
            font-size: 1.5rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .carousel__btn:hover {
            background-color: #000;
          }

          /* Horizontal Line */
          .carousel__hr {
            width: 32%;  /* Set to 32% of container width */
            height: 4px;
            border: none;
            background-color: rgb(236 115 34);  /* Block color */
            margin: 20px auto;  /* Center align and space it */
            margin-top: 392px;
            
            transition: width 0.3s ease-in-out; /* Smooth transition */
          }
           @media (min-width: 1354px) {
           .carousel__hr {
           margin-left: -974px;
        }

        }
        @media (max-width: 1353px) {
         .carousel__hr {
           margin-left: -763px !important;
        }


        }
          @media (min-width: 1635px) {
           .carousel__hr {
            margin-left: -1183px !important;
            
        }


       @media (max-width: 1024px) {
  .carousel-container {
    height: 70%;
  }
  
  .carousel__item {
    height: 18rem;
    width: 22rem;
  }

  .carousel__description {
    font-size: 0.8rem;
  }

  .carousel__btn {
    height: 2.5rem;
    width: 2.5rem;
    font-size: 1.2rem;
  }

  .carousel__hr {
    width: 70%;
  }
}

@media (max-width: 768px) {
  .carousel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .carousel__item {
    display: none; /* Hide all images */
    transform: none; /* Remove scaling */
    position: static; /* Remove absolute positioning */
    height: auto;
    width: 100%;
    max-width: 300px;
    margin: 10px auto;
  }

  .carousel__item--main {
    display: block; /* Show only the current image */
    transform: none; /* Remove scaling */
  }

  .carousel__btns {
    position: static;
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
}


@media (max-width: 480px) {
  .page-container {
    max-width: 95%;
    height: auto;
  }

  .carousel-container {
    width: 95%;
    max-width: 280px;
  }

  .carousel__item {
    width: 85%;
    max-width: 220px;
  }

  .carousel__description {
    font-size: 0.75rem;
    padding: 0.6rem;
  }

  .carousel__btn {
    height: 1.6rem;
    width: 1.6rem;
    font-size: 0.8rem;
  }

  .carousel__hr {
    width: 90%;
  }
}


        `}</style>
      </div>
    </div>
  );
};

export default AerospaceanimatedCards;
